export class dateHelper {
    convert(param) {
        var date = new Date(param), month = ("0" + (date.getMonth() + 1)).slice(-2), day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), month, day].join("/");
    }
}
export const dateHelpers = new dateHelper();
// Calendar quarter (not fiscal), 1-4. Decorative/filter-only - quarter is never persisted.
export const getQuarterNumber = (date) => {
    return Math.floor(new Date(date).getMonth() / 3) + 1;
};
// e.g. "Q3 2026" (calendar quarter, not fiscal).
export const getQuarterLabel = (date) => {
    const d = new Date(date);
    return `Q${getQuarterNumber(d)} ${d.getFullYear()}`;
};
